import { HTMLAttributeAnchorTarget } from 'react'
import { LoadingIcon } from 'components/icons'
import PropertyCard from './PropertyCard'
import {
  AllPropertiesQuery,
  CuratedPropertiesPageQuery,
  DestinationCountryPagePropertiesQuery,
  DestinationRegionPagePropertiesQuery,
  DestinationSubRegionPagePropertiesQuery,
  WishlistQuery,
} from 'gql/graphql'
import { useSearchParams } from 'data/hooks/useSearchParams'

interface PropertyGridDisplayProps {
  properties: CuratedPropertiesPageQuery['properties']['data']
    | NonNullable<WishlistQuery['wishlist']>['properties']['data']
    | AllPropertiesQuery['properties']['data']
    | NonNullable<DestinationCountryPagePropertiesQuery['country']>['properties']['data']
    | NonNullable<DestinationRegionPagePropertiesQuery['region']>['properties']['data']
    | NonNullable<DestinationSubRegionPagePropertiesQuery['subRegion']>['properties']['data']
  isLoading: boolean
  target?: HTMLAttributeAnchorTarget
}

const PropertyGridDisplay = ({
  properties = [],
  isLoading = false,
  target = '_self',
}: PropertyGridDisplayProps) => {
  // TODO: Bring back Property Fragments
  // const propertyItems = useFragment(PropertyCard_PropertyFragment, properties)
  const { params } = useSearchParams()

  return (
    <>
      {properties.length
        ? <div className="grid w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-25 gap-y-60">
          {properties.map(property => (
            <PropertyCard
              key={`property-${property.id}`}
              property={property}
              target={target}
              url={{
                pathname: `/${property.url}`,
                query: {
                  adults: params.get('adults'),
                  children: params.get('children'),
                  arrival: params.get('arrival'),
                  departure: params.get('departure'),
                },
              }}
            />
          ))}
        </div>
        : <div className="mx-auto antialiased font-normal text-grey-750 w-max">
          {!isLoading && 'No properties found matching these criteria.'}
        </div>
      }
      {
        isLoading
        && <div className="flex justify-center mx-auto pt-50">
          <LoadingIcon />
        </div>
      }
    </>
  )
}

export default PropertyGridDisplay
